import moduleLayout from "@/view/bankAc/layout.vue";

export default {
    // bank account
    path: "/bankac",
    component: moduleLayout,
    redirect: "/bankac/list",
    name: "BankAccountManage",
    meta: {
        title: "流水管理"
    },
    children: [
        {
            path: "list",
            name: "BankacList",
            component: () => import("@/view/bankAc/accountList/index.vue")
        },
        {
            path: "match",
            name: "BankacMatch",
            component: () => import("@/view/bankAc/accountMatch/index.vue")
        },
        {
            path: "confirm",
            name: "BankacConfirm",
            component: () => import("@/view/bankAc/confirmList/index.vue")
        },
        {
            path: "match_tmp",
            name: "BankacClaim",
            component: () => import("@/view/bankAc/accountClaim/indexold.vue")
        },
        {
            path: "match_tmp2",
            name: "AccountClaim2",
            component: () => import("@/view/bankAc/accountClaim/indexnew.vue")
        }
    ]
};



// WEBPACK FOOTER //
// ./src/router/modules/bankAccount.js